import React from "react";
import Header from "../nav/Header";
import Mamakit from "./media/mamakit.png";
import Herkit from "./media/herkit.png";
import Safekit from "./media/safekit.png";
import {
  Card,
  CardHeader,
  CardTitle,
  CardImage,
  CardSubtitle,
  CardBody,
} from "@progress/kendo-react-layout";

function Kits() {
  return (
    <React.Fragment>
      <Header />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">
              Kits - Curated with{" "}
              <span
                class="k-icon k-i-heart"
                style={{ color: "red", fontSize: "30px" }}
              ></span>
            </h1>
            <h2 className="sub-header mt-0">
              Kits are a collection of items for different purposes. From your
              periods to maternity needs. We've got you covered
            </h2>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            <h1 className="get-started">MAMA Kit</h1>
          </div>
          <div className="col-6 text-right">
            <img src={Mamakit} alt="kendoka" width="400px" />
          </div>
          <div className="col-6 components-list">
            <h3 className="welcome">Kit Contains</h3>
            <p>
              Blankets, Socks, Onsies, Cap, Bottle, Wipes, Maternity Gown,
              Hospital Bag...
            </p>
            <p>
              Kits available: <strong>(5)</strong>
            </p>
            <h4>
              Price: GHC300 <small>(Delivery included)</small>
            </h4>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            <h1 className="get-started">HER Kit</h1>
          </div>
          <div className="col-6 components-list">
            <h3 className="welcome">Kit Contains</h3>
            <p>
              Wipes, Sanitary Pads, Panty Liners, Mint Tea, Pain killers, Socks,
              Feminine Wash...
            </p>
            <p>
              Kits available: <strong>(10)</strong>
            </p>
            <h4>
              Price: GHC100 <small>(Delivery included)</small>
            </h4>
          </div>
          <div className="col-6 text-right">
            <img src={Herkit} alt="kendoka" width="400px" />
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            <h1 className="get-started">SAFE Kit</h1>
          </div>
          <div className="col-6 text-right">
            <img src={Safekit} alt="kendoka" width="400px" />
          </div>
          <div className="col-6 components-list">
            <h3 className="welcome">Kit Contains</h3>
            <p>
              Emergency Contraceptives, Panty-Liners, Toothpaste, Condoms,
              Wipes, Flosss...
            </p>
            <p>
              Kits available: <strong>(2)</strong>
            </p>
            <h4>
              Price: GHC50 <small>(Delivery included)</small>
            </h4>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h2 className="sub-header mt-0">
              Call/Whatsapp us on: +233200000 to Order. Deliveries within
              Greater Accra only. Package can be modified to suit your needs
            </h2>
          </div>
        </div>
        <hr style={{ borderColor: "#E84393" }} />
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">This Month's Virtual Kit</h1>
            <h2 className="sub-header mt-0">
              Freebies for the Month of MAY....YAY!! Right Click on Image to
              download. Alternatively, if you are subscribed to our newsletter,
              you should get an email containing this month's virtual kit.
            </h2>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-3">
            <Card>
              <CardImage src="https://i.pinimg.com/originals/16/fa/5f/16fa5f3a21983d7a1793104c69e16899.jpg" />
              <div>
                <CardHeader>
                  <CardTitle>Hospital Checklist</CardTitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-3">
            <Card>
              <CardImage src="https://image.slidesharecdn.com/ancipnc-120509103858-phpapp01/95/antenatal-care-1-728.jpg?cb=1361793694" />
              <div>
                <CardHeader>
                  <CardTitle>Antenatal Care Timeline</CardTitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-3">
            <Card>
              <CardImage src="https://i.pinimg.com/originals/9e/7f/f0/9e7ff0e2790ffc9516fc2fdece96dd74.png" />
              <div>
                <CardHeader>
                  <CardTitle>Hospital Checklist Two</CardTitle>
                </CardHeader>
              </div>
            </Card>
          </div>
          <div className="col-3">
            <Card>
              <CardImage src="https://i.pinimg.com/736x/a8/fc/62/a8fc625b580dc3dc735e88810bf6e838.jpg" />
              <div>
                <CardHeader>
                  <CardTitle>GHC200 coupon for Babies'R'Us shop</CardTitle>
                </CardHeader>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Kits;
